const filterExistingDocuments = (newDocs, existingDocs = []) => {
  return (newDocs || []).filter(
    (doc) => !existingDocs.some((e) => e.id === doc.id),
  )
}

export default filterExistingDocuments
